<template>
    <div class="zebra-crossing-detail">
        <el-form :model="detail">
            <div class="zebra-item">
                <div class="zebra-item_tit">变更登记单</div>
                <!--所属公司 报告人-->
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="所属公司：">{{ detail.company | tableVal(companyList,'n')}}</el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="报告人：">{{ detail.requester.name }}</el-form-item>
                    </el-col>
                </el-row>
                <!--变更类型  变更分类-->
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="变更类型：">{{ detail.changeType |  tableVal(changeType)}}</el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="变更分类：">{{ detail.category | tableVal(changeList,'t') }}</el-form-item>
                    </el-col>
                </el-row>


                <el-row>
                    <el-col :span="12">
                        <el-form-item label="计划开始：">{{ detail.startTime }}</el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="计划发布：">{{ detail.endTime }}</el-form-item>
                    </el-col>
                </el-row>

                <!--变更标题-->
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="变更标题：">{{detail.title}}</el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="风险等级：">{{ detail.risk | tableVal(risk) }}</el-form-item>
                    </el-col>
                </el-row>

                <!--优先级  变更来源-->
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="优先级：">{{ detail.priority | tableVal(priority) }}</el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="变更来源：">{{ detail.changeOrigin | tableVal(changeOrigin)}}</el-form-item>
                    </el-col>

                </el-row>
                <!--影响范围  紧急度 -->
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="影响范围：">{{ detail.influence | tableVal(influence)}}</el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="紧急度：">{{ detail.emergency | tableVal(emergency) }}</el-form-item>
                    </el-col>

                </el-row>

                <!--标签 -->
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="标签：">
                            <span v-for="item in detail.label">{{ item }}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="完成时间：">
                            {{detail.endTime}}
                        </el-form-item>
                    </el-col>
                </el-row>
                <!--完成程度-->
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="完成程度：">
                            {{detail.completionDegree|tableVal(completionDegree)}}
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="项目名称：">
                           {{detail.projectName|tableVal(projectName)}}
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="服务请求：">{{detail.serviceClass| tableVal(serviceClass)}}</el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="环境：">{{detail.env| tableVal(env)}}</el-form-item>
                    </el-col>
                </el-row>
                <!--上传附件-->
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="上传附件：">
                            <ul>
                                <li v-for="item in detail.attachment" >
                                    <a :href="item.url" style="color: #1890EF">{{ item.name }}</a>
                                    <span>上传时间:&emsp;{{item.uploadTime?item.uploadTime:'无'}}</span>
                                    <span class="preview" @click="previewEvent(item)">预览</span>
                                </li>
                            </ul>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="是否高危操作：">
                            {{detail.isHighRiskOperation ?'是':'否'}}
                        </el-form-item>
                    </el-col>
                </el-row>
                <!--变更影响-->
                <el-row>
                    <el-col :span="24">
                        <el-form-item  label="变更影响：" >{{detail.influenceDes}}</el-form-item>
                    </el-col>
                </el-row>
                <!--上线计划-->
                <el-row>
                    <el-col :span="24">
                        <el-form-item  label="上线计划：" >{{detail.deployPlan}}</el-form-item>
                    </el-col>
                </el-row>
                <!--回退计划-->
                <el-row>
                    <el-col :span="24">
                        <el-form-item  label="回退计划：" >{{detail.rollbackPlan}}</el-form-item>
                    </el-col>
                </el-row>
                <!--测试计划-->
                <el-row>
                    <el-col :span="24">
                        <el-form-item  label="测试方案：" >{{detail.testPlan}}</el-form-item>
                    </el-col>
                </el-row>
                <!--详情描述-->
                <el-row>
                    <el-col :span="24">
                        <el-form-item  label="详细描述：" >
                            <span v-html="detail.description"></span>
                        </el-form-item>
                    </el-col>
                </el-row>

            </div>
        </el-form>
    </div>
</template>

<script>
    import commonService from "../../../services/common.service"
    export default {
        props:{
            detail:Object,
            companyList:Array,
            changeList:Array,
        },
        data() {
            return {

            }
        },
        created() {
        },
        computed:{
            dictionary(){
                return this.$store.state.dictionary;
            },
            changeType(){
              return this.dictionary.change_type;
            },
            //变更分类
            changeCategory(){
                return this.dictionary.change_category;
            },
            // 优先级
            priority(){
                return this.dictionary.priority;
            },

            // 影响范围
            influence(){
                return this.dictionary.influence;
            },
            // 紧急度
            emergency(){
                return this.dictionary.emergency;
            },
            //变更来源
            changeOrigin(){
                return this.dictionary.change_origin;
            },
            //风险等级
            risk(){
                return this.dictionary.change_risk
            },
            completionDegree(){
                return this.dictionary.completion_degree
            },
            //环境
            env(){
                return this.dictionary.env
            },
            //项目名称
            projectName(){
                return this.dictionary.project_name
            },
            //服务请求
            serviceClass(){
                return this.dictionary.service_class
            },
        },
        methods: {
            previewEvent(row){
                this.$router.push({
                    name:'Preview',
                    path:'/preview',
                    query: {
                        file:row
                    }
                })
            }
        }
    }
</script>

<style scoped>
    .zebra-crossing-detail .zebra-item .el-form-item__content a{
        float: left;
        margin-left: 20px;
    }
    .preview{
        color:blue;
        cursor: pointer;
        margin-left: 10px;
    }
</style>
